const aLogoEdition = {
  aLogoEdition: {
    academia: {
      label: 'Logo de Academia',

      messages: {
        dimensions: '* Tamaño sugerido de imagen: 173px de ancho por 41px de alto',
        extensions: '* Formatos permitidos de imagen: .gif .jpg .png'
      },

      tooltipModify: 'Modificar'
    },

    changeLogo: 'cambiar logo',

    punto_venta: {
      label: 'Logo de Punto de Venta',

      messages: {
        dimensions: '* Tamaño sugerido de imagen: 200px de ancho por 200px de alto',
        extensions: '* Formatos permitidos de imagen: .png'
      },

      tooltipModify: 'Modificar'
    },

    validation: {
      file: {
        extension: 'Extensión de imagen no permitida.',
        size: 'Tamaño de imagen no permitido.'
      }
    }
  }
}

export default aLogoEdition
